import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import "./style.scss";
import uris from "../../../../config/uris";

const PaymentCancel = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // setTimeout(() => {
        //     navigate(uris?.stripeCheckout);
        // }, 5000);
    }, [])

    return (
        <div className="payment-cancel-card">
            <div className="payment-cancel-content">
                <div className="card-title">Payment Cancelled</div>
                <div className="card-description">Your payment was canceled. Please try again.</div>
            </div>
        </div>
    )
}

export default PaymentCancel;